import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const getStakeholderMandatoryFields = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/stk-auth/stk`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};
